import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Es para principiantes?',
  answer: 'Absolutamente. El ebook está diseñado para llevarte de la mano desde cero. Explicamos cada término, cada técnica y cada paso con claridad para que no te sientas perdido en ningún momento.'
}, {
  question: '¿Necesito batidora?',
  answer: 'No es estrictamente necesaria. Todas las recetas incluyen instrucciones para amasar a mano. Una batidora te ahorrará tiempo y esfuerzo, pero el pan artesanal perfecto se puede lograr perfectamente con tus manos.'
}, {
  question: '¿Las recetas están en gramos?',
  answer: 'Sí. Para lograr resultados consistentes en panadería, la precisión es clave. Todas las recetas están en gramos (sistema métrico), por lo que recomendamos tener una báscula de cocina.'
}, {
  question: '¿Puedo vender estos panes?',
  answer: '¡Por supuesto! Muchos de nuestros lectores han iniciado pequeños negocios desde casa utilizando estas recetas. Las fórmulas están diseñadas para ser escalables y rentables.'
}, {
  question: '¿Cómo recibo el ebook?',
  answer: 'Una vez completado el pago, recibirás inmediatamente un correo electrónico con el enlace para descargar el ebook en formato PDF de alta calidad, listo para leer en cualquier dispositivo o imprimir.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-62">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-64">
          <h2 className="text-4xl font-bold text-espresso" data-id="element-65">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-beige bg-warm-white overflow-hidden" data-id="element-67">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-68">
                <span className="font-serif text-lg font-medium text-espresso" data-id="element-69">
                  {faq.question}
                </span>
                <ChevronDown className={`text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-70" />
              </button>
              <AnimatePresence data-id="element-71">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-72">
                    <div className="px-6 pb-5 text-espresso/80 leading-relaxed" data-id="element-73">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}